import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#033530] shadow-lg' : 'bg-[#033530]/95'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center">
              <img 
                src="/assets/logo-new.png" 
                alt="Amanda Sales Logo" 
                className="w-full h-full object-contain"
              />
            </div>
            <div className="flex flex-col">
              <h1 className="text-xl md:text-2xl font-bold text-[#ddc183] leading-tight" style={{ fontFamily: "'Cinzel Decorative', serif" }}>
                Amanda Sales
              </h1>
              <span className="text-xs text-[#e8d6b2]">
                Engenharia & Perícia
              </span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-[#e8d6b2] hover:text-[#ddc183] transition-colors duration-200 text-sm font-medium"
            >
              Início
            </button>
            <button 
              onClick={() => scrollToSection('portfolio')}
              className="text-[#e8d6b2] hover:text-[#ddc183] transition-colors duration-200 text-sm font-medium"
            >
              Áreas de Atuação
            </button>
            <button 
              onClick={() => scrollToSection('portfolio')}
              className="text-[#e8d6b2] hover:text-[#ddc183] transition-colors duration-200 text-sm font-medium"
            >
              Portfólio
            </button>
            <button 
              onClick={() => scrollToSection('diferenciais')}
              className="text-[#e8d6b2] hover:text-[#ddc183] transition-colors duration-200 text-sm font-medium"
            >
              Diferenciais
            </button>
            <button 
              onClick={() => scrollToSection('contato')}
              className="bg-[#ddc183] text-[#033530] px-6 py-2.5 rounded-md hover:bg-[#c9af71] transition-colors duration-200 font-semibold text-sm"
            >
              Contato
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-[#e8d6b2] hover:text-[#ddc183] transition-colors duration-200"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden py-4 border-t border-[#ddc183]/20">
            <div className="flex flex-col space-y-3">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-[#e8d6b2] hover:text-[#ddc183] transition-colors duration-200 text-sm font-medium text-left py-2"
              >
                Início
              </button>
              <button 
                onClick={() => scrollToSection('portfolio')}
                className="text-[#e8d6b2] hover:text-[#ddc183] transition-colors duration-200 text-sm font-medium text-left py-2"
              >
                Áreas de Atuação
              </button>
              <button 
                onClick={() => scrollToSection('portfolio')}
                className="text-[#e8d6b2] hover:text-[#ddc183] transition-colors duration-200 text-sm font-medium text-left py-2"
              >
                Portfólio
              </button>
              <button 
                onClick={() => scrollToSection('diferenciais')}
                className="text-[#e8d6b2] hover:text-[#ddc183] transition-colors duration-200 text-sm font-medium text-left py-2"
              >
                Diferenciais
              </button>
              <button 
                onClick={() => scrollToSection('contato')}
                className="bg-[#ddc183] text-[#033530] px-6 py-2.5 rounded-md hover:bg-[#c9af71] transition-colors duration-200 font-semibold text-sm"
              >
                Contato
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
